import { memo } from "react";
import { KnowledgeCaptureToast } from "./components/knowledge-capture-toast";

export const KnowledgeCaptureRenderer = memo(
  function KnowledgeCaptureRenderer() {
    return <KnowledgeCaptureToast />;
  },
);
